import { Link, usePage } from "@inertiajs/react";

type NavLinkProps = {
  to: string;
  children?:
    | React.ReactNode
    | ((state: { isActive: boolean }) => React.ReactNode);
};

export function NavLink({ to, children }: NavLinkProps) {
  const { url } = usePage();
  const isActive = url === to;

  return (
    <Link href={to} viewTransition>
      {typeof children === "function" ? children({ isActive }) : children}
    </Link>
  );
}
